import {useEffect, useRef, useState} from 'react';

export default function usePopupAnimation(isOpen, animationMs = 300) {
	const [shouldRender, setShouldRender] = useState(isOpen);
	const [isClosing, setIsClosing] = useState(false);
	const closeTimeoutRef = useRef(null);

	useEffect(() => {
		return () => {
			if (closeTimeoutRef.current) {
				clearTimeout(closeTimeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
			closeTimeoutRef.current = null;
		}

		if (isOpen) {
			setShouldRender(true);
			setIsClosing(false);
			return;
		}

		if (!shouldRender) {
			return;
		}

		setIsClosing(true);
		closeTimeoutRef.current = setTimeout(() => {
			setShouldRender(false);
			setIsClosing(false);
			closeTimeoutRef.current = null;
		}, animationMs);
	}, [animationMs, isOpen, shouldRender]);

	return {shouldRender, isClosing};
}